const ROOT = 'CipReport/report/report';

export const FILTER_VALUES = `${ROOT}/FILTER_VALUES`;
